import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

export const fetchTemplateByIdQuery = gql`
  query getTemplateById($id: Long!) {
    template(id: $id) {
      name
      id
      messageMedium
    }
  }
`;

export const useGetTemplateResourceData = (id: number) => {
  const {
    data = {},
    isLoading,
    error,
  } = useGraphql(fetchTemplateByIdQuery, {
    variables: { id },
  });

  return {
    resource: data.template || {},
    isLoading,
    hasError: !!error,
  };
};
